// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfAanvragenMutatieredenenGetMogelijkeMutatieRedenenDto } from '../model/collectionResultOfAanvragenMutatieredenenGetMogelijkeMutatieRedenenDto.ts';

import type { MutatieRedenenGetParams } from '../model/mutatieRedenenGetParams.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Haalt de mutatieredenen voor een soort verzekering en soort mutatie
 */
export const mutatieRedenenGet = (
  params?: MaybeRefOrGetter<MutatieRedenenGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfAanvragenMutatieredenenGetMogelijkeMutatieRedenenDto>(
    { url: `/api/v1/muteren/mutatieredenen`, method: 'GET', params, signal },
    options,
  );
};

export const getMutatieRedenenGetQueryKey = (
  params?: MaybeRefOrGetter<MutatieRedenenGetParams>,
) => {
  return ['api', 'v1', 'muteren', 'mutatieredenen', ...(params ? [params] : [])] as const;
};

export const getMutatieRedenenGetQueryOptions = <
  TData = Awaited<ReturnType<typeof mutatieRedenenGet>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRefOrGetter<MutatieRedenenGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mutatieRedenenGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMutatieRedenenGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof mutatieRedenenGet>>> = ({ signal }) =>
    mutatieRedenenGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mutatieRedenenGet>>,
    TError,
    TData
  >;
};

export type MutatieRedenenGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof mutatieRedenenGet>>
>;
export type MutatieRedenenGetQueryError = ErrorType<unknown>;

/**
 * @summary Haalt de mutatieredenen voor een soort verzekering en soort mutatie
 */

export function useMutatieRedenenGet<
  TData = Awaited<ReturnType<typeof mutatieRedenenGet>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRefOrGetter<MutatieRedenenGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof mutatieRedenenGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMutatieRedenenGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
